/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Pokračovat v nákupu`
};

const da_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Fortsæt med at handle`
};

const de_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Weiter einkaufen`
};

const en_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Continue shopping`
};

const es_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Seguir comprando`
};

const fr_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Continuer mes achats`
};

const hu_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Vásárlás folytatása`
};

const it_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Continua lo shopping`
};

const nl_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Verder winkelen`
};

const pl_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Kontynuuj zakupy`
};

const pt_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Continuar comprando`
};

const sv_continue_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Fortsätt handla`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const continue_shopping = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.continue_shopping(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("continue_shopping", locale)
	if (locale === "cs") return cs_continue_shopping(inputs)
	if (locale === "da") return da_continue_shopping(inputs)
	if (locale === "de") return de_continue_shopping(inputs)
	if (locale === "en") return en_continue_shopping(inputs)
	if (locale === "es") return es_continue_shopping(inputs)
	if (locale === "fr") return fr_continue_shopping(inputs)
	if (locale === "hu") return hu_continue_shopping(inputs)
	if (locale === "it") return it_continue_shopping(inputs)
	if (locale === "nl") return nl_continue_shopping(inputs)
	if (locale === "pl") return pl_continue_shopping(inputs)
	if (locale === "pt") return pt_continue_shopping(inputs)
	return sv_continue_shopping(inputs)
};